/** Classes for the profile image block. */

export const container = noBorder => [
  'grid justify-items-center items-center p-8 gap-4 rounded-md',
  noBorder ? '' : 'border border-[var(--cck-border,#E2E8F0)] dark:border-[var(--cck-border-dark,rgba(255,255,255,0.16))]'
].join(' ')

export const title = 'text-center self-start text-[25px] text-gray-600 dark:text-gray-400'
